@if (smsForm) {
  <div class="email-list ag-pa-md">
    <h4>Send SMS</h4>
    <form (ngSubmit)="sendSMS(smsForm)" [formGroup]="smsForm">
      <div class="form-group">
        <input
          type="tel"
          title="Telephone Number"
          class="form-control"
          id="PhoneNumber"
          formControlName="phoneNumber"
          aria-describedby="phoneNumHelp"
          placeholder="Enter Phone Number:0000000000"
        />
      </div>
      <div class="form-group">
        <textarea
          class="form-control"
          id="messageBody"
          formControlName="messageBody"
          [rows]="row"
          title="Type Message Here..."
        ></textarea>
      </div>
      <button
        role="button"
        aria-label="Send"
        type="submit"
        class="btn btn-primary"
        [disabled]="!smsForm.valid"
      >
        Send
      </button>
    </form>
  </div>
}
